var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeamlessCommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 85,
    viewBox: "0 0 90 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.7405 31.6626H77.8132L68.3 38.8696L68.2248 31.6626H64.4987C62.3237 31.6626 60.5596 29.8922 60.5596 27.7094V15.3488C60.5596 13.1659 62.3237 11.3955 64.4987 11.3955H84.7405C86.9155 11.3955 88.6796 13.1659 88.6796 15.3488V27.7094C88.6796 29.8922 86.9155 31.6626 84.7405 31.6626Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93908 35.981H9.71503L19.2282 41.8925L19.3035 35.981H20.8783C23.0533 35.981 24.8173 34.2106 24.8173 32.0277V19.6671C24.8173 17.4843 23.0533 15.7139 20.8783 15.7139H4.93908C2.76409 15.7139 1 17.4843 1 19.6671V32.0277C1 34.2106 2.76409 35.981 4.93908 35.981Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6826 8.20117H49.8913",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80371 23.0938H16.0146",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83789 28.8018H16.0466",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2734 8.20117H38.8744",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2734 14.1572H49.8913",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0183 17.998H67.8096",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4302 17.998H78.8271",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8096 23.9551H81.4296",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2734 20.1123H46.2857",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5818 1H35.0643C32.472 1 30.3701 3.1094 30.3701 5.71107V22.6014C30.3701 25.2031 32.472 27.3125 35.0643 27.3125H38.7883L43.0823 32.7015L47.3764 27.3125H50.5797C53.172 27.3125 55.2739 25.2031 55.2739 22.6014V5.71107C55.2739 3.1094 53.172 1 50.5797 1H50.5818Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1873 48.7395C66.1873 52.0105 63.5455 55.6722 60.2841 55.6722C57.0227 55.6722 54.3809 52.0105 54.3809 48.7395C54.3809 45.4685 57.0227 43.2188 60.2841 43.2188C63.5455 43.2188 66.1873 45.4663 66.1873 48.7395Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1473 48.7395C33.1473 52.0105 30.5055 55.6722 27.2441 55.6722C23.9827 55.6722 21.3408 52.0105 21.3408 48.7395C21.3408 45.4685 23.9827 43.2188 27.2441 43.2188C30.5055 43.2188 33.1473 45.4663 33.1473 48.7395Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8095 45.4549C50.8095 49.4362 47.5954 53.8904 43.6284 53.8904C39.6613 53.8904 36.4473 49.4362 36.4473 45.4549C36.4473 41.4736 39.6613 38.7402 43.6284 38.7402C47.5954 38.7402 50.8095 41.4758 50.8095 45.4549Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8706 81.5413V69.3016V81.7248C34.8706 83.6896 52.2813 83.6896 52.2813 81.7248V69.3016V81.5413H56.5538C57.7822 81.5413 59.3721 80.464 59.2258 79.2398L58.5524 69.0943C58.5524 63.7139 54.9102 60.0241 50.5301 59.3526C48.7294 59.0763 45.4099 58.8625 43.6975 58.8604C41.9248 58.8582 38.4181 59.1065 36.6196 59.3526C32.2288 59.9529 28.5973 63.7139 28.5973 69.0943L28.0294 79.2614C27.896 80.4791 29.4837 81.5413 30.7035 81.5413H34.8684H34.8706Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1845 79.7541C63.0763 79.8426 67.3961 79.441 67.3961 78.5536V68.3413V78.4003H70.9092C71.9182 78.4003 73.2262 77.5151 73.1058 76.509L72.5529 68.1685C72.5529 63.7468 69.5582 60.7133 65.959 60.1606C64.4789 59.9339 61.751 59.759 60.3419 59.7568C58.8833 59.7568 56.0005 59.9576 54.5247 60.1606C54.1956 60.2059 53.8729 60.2728 53.5566 60.3592",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8318 60.359C33.5327 60.2748 33.2273 60.21 32.9175 60.1625C31.4373 59.9358 28.7095 59.7609 27.3003 59.7588C25.8417 59.7588 22.9611 59.9596 21.4832 60.1625C17.8754 60.657 14.8893 63.7466 14.8893 68.1705L14.4225 76.5282C14.3128 77.5279 15.6186 78.4023 16.6212 78.4023H20.0439V68.3432V78.5556C20.0439 79.4408 24.3401 79.8402 28.2233 79.756",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeamlessCommunication);
export default __webpack_public_path__ + "static/media/seamless-communication.452e6e25c875400567c82dcb06ec4e25.svg";
export { ForwardRef as ReactComponent };